import type { MatchUpFormatInterface } from 'typedefs/scoreFormatTypes';

export function matchUpFormats(scoringPolicy) {
  const formats = [...(scoringPolicy?.matchUpFormats ?? [])] as MatchUpFormatInterface[];
  const defaultMatchFormat = scoringPolicy?.defaultMatchUpFormat as string;
  const lookup = (key) => formats.reduce((p, c) => (c.key === key ? c.matchUpFormat : p), defaultMatchFormat);
  const sortedFormats = [...formats].sort((a, b) =>
    a.description > b.description ? 1 : a.description < b.description ? -1 : 0,
  );

  return { formats: sortedFormats, lookup, default: defaultMatchFormat };
}
